// @ts-ignore
import { createBrowserHistory } from 'history'

export default createBrowserHistory();
